/* Styled Components */
import {
  Wrapper,
  Title,
  SubTitle,
  Question,
  Answer,
  Footnote,
  CollapsibleSectionWrapper,
} from 'styles/landing/CollapsibleFAQ';

/* Child Components */
import CollapsibleSection from 'components/common/CollapsibleSection';

/* Utils */
import { i18n } from 'utils/i18n';
import {
  sendGAEvent,
  GA_GROUP_NAME,
  EVENT_ACTION,
} from 'utils/GoogleAnalytics';

/* Constants */
import { FAQS } from 'constants/LandingPageConstants';

const CollapsibileFAQ = () => {
  return (
    <Wrapper>
      <Title>{i18n('FAQs')}</Title>
      <SubTitle>
        {i18n(
          'Learn more about how the program works and what it can do for your business',
        )}
      </SubTitle>
      {FAQS().map(({ question, answer, footnote }, index) => (
        <CollapsibleSectionWrapper
          key={question}
          onClick={() =>
            sendGAEvent(GA_GROUP_NAME, EVENT_ACTION.FAQ_CLICK, {
              event_label: `question_${index + 1}`,
            })
          }
        >
          <CollapsibleSection
            title={<Question>{question}</Question>}
            body={
              <>
                <Answer>{answer}</Answer>
                {footnote && <Footnote>{`*${footnote}`}</Footnote>}
              </>
            }
          />
        </CollapsibleSectionWrapper>
      ))}
    </Wrapper>
  );
};

export default CollapsibileFAQ;
